import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />

        <footer>
          This project was coded by{""}
          <a
            href="https://www.linkedin.com/in/muna-ali-9a334422a/"
            target="_blank"
            rel="noopener noreferrer"
          >

             Muna Ali
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/MunaFrontend/weather-react"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://delicate-blini-72f3b5.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}